import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { StorageService } from './storage.service';
import { throwError } from 'rxjs';
import { ReglamentoInternoModel } from '../model/ReglamentoInterno.model';

const getReglamentoInterno = 'reglamentoInterno/';
const saveReglamentoInterno = 'reglamentoInterno/';
const sendReglamentoInterno = 'reglamentoInterno/enviar/';
const postCargarArchivoReglamento = 'reglamentoInterno/cargarArchivo/';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
}; 
@Injectable({
  providedIn: 'root'
})
export class ReglamentoInternoService {
  

  constructor(private http:HttpClient,private storageService: StorageService) { }

  API_GET_getReglamentoInterno(idJardinPeriodo: number) {
    return this.http.get(environment.apiEndpoint + getReglamentoInterno + idJardinPeriodo, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_POST_saveReglamentoInterno(idJardinPeriodo: number, reglamentoInterno:ReglamentoInternoModel) {
    return this.http.post(environment.apiEndpoint + saveReglamentoInterno + idJardinPeriodo, reglamentoInterno, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  API_PUT_enviarReglamentoInterno(idJardinPeriodo: number, reglamentoInterno: ReglamentoInternoModel) {
    return this.http.post(environment.apiEndpoint + sendReglamentoInterno + idJardinPeriodo, reglamentoInterno, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  API_POST_guardarArchivoReglamento(idJardinPeriodo: number, dataArchivo: FormData) {
    return this.http.post(environment.apiEndpoint + postCargarArchivoReglamento + idJardinPeriodo, dataArchivo, httpOptionsFile).pipe(
      catchError(this.handleError)
    );
  }



  handleError(error) {    
    let errorMessage = '';
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
    return throwError(errorMessage);
  }

}
